// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"V2-z"};